import React, { useState, useEffect, FormEvent } from 'react';

const SITE_PASSWORD = 'qweqwe123';
const STORAGE_KEY = 'site_access_granted';

const PasswordGate: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [authorized, setAuthorized] = useState(false);
  const [password, setPassword] = useState('');
  const [error, setError] = useState(false);

  useEffect(() => {
    if (sessionStorage.getItem(STORAGE_KEY) === 'true') {
      setAuthorized(true);
    }
  }, []);

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    if (password === SITE_PASSWORD) {
      sessionStorage.setItem(STORAGE_KEY, 'true');
      setAuthorized(true);
    } else {
      setError(true);
      setPassword('');
    }
  };

  if (authorized) {
    return <>{children}</>;
  }

  return (
    <div style={styles.overlay}>
      <form onSubmit={handleSubmit} style={styles.card}>
        <div style={styles.lock}>🔒</div>
        <h2 style={styles.title}>Prieiga ribota</h2>
        <p style={styles.subtitle}>Įveskite slaptažodį, kad galėtumėte tęsti</p>
        <input
          type="password"
          value={password}
          onChange={(e) => { setPassword(e.target.value); setError(false); }}
          placeholder="Slaptažodis"
          style={{
            ...styles.input,
            borderColor: error ? '#e74c3c' : '#ddd',
          }}
          autoFocus
        />
        {error && <p style={styles.error}>Neteisingas slaptažodis</p>}
        <button type="submit" style={styles.button}>
          Prisijungti
        </button>
      </form>
    </div>
  );
};

const styles: Record<string, React.CSSProperties> = {
  overlay: {
    position: 'fixed',
    inset: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
    zIndex: 99999,
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
  },
  card: {
    background: '#fff',
    borderRadius: '16px',
    padding: '48px 40px',
    boxShadow: '0 20px 60px rgba(0,0,0,0.12)',
    textAlign: 'center' as const,
    maxWidth: '400px',
    width: '90%',
  },
  lock: {
    fontSize: '48px',
    marginBottom: '16px',
  },
  title: {
    fontSize: '24px',
    fontWeight: 700,
    color: '#2C3E50',
    marginBottom: '8px',
  },
  subtitle: {
    fontSize: '14px',
    color: '#7f8c8d',
    marginBottom: '28px',
  },
  input: {
    width: '100%',
    padding: '14px 16px',
    fontSize: '16px',
    border: '2px solid #ddd',
    borderRadius: '10px',
    outline: 'none',
    transition: 'border-color 0.2s',
    marginBottom: '8px',
  },
  error: {
    color: '#e74c3c',
    fontSize: '13px',
    marginBottom: '4px',
  },
  button: {
    width: '100%',
    padding: '14px',
    fontSize: '16px',
    fontWeight: 600,
    color: '#fff',
    background: '#23928B',
    border: 'none',
    borderRadius: '10px',
    cursor: 'pointer',
    marginTop: '12px',
    transition: 'background 0.2s',
  },
};

export default PasswordGate;
